import { Divider } from '@mui/material';

import { SectionSkeleton } from 'components/shared/MultiStepForm/Skeletons/SectionSkeleton';

export const EditDistancesSkeleton = () => (
  <>
    <SectionSkeleton height={220} />
    <Divider />
    <SectionSkeleton />
    <Divider />
    <SectionSkeleton />
  </>
);
